import { FieldMetaProps } from "formik";

export function getFieldMetaError(meta: FieldMetaProps<any>): string | undefined {
    if(meta.touched && typeof meta.error === 'string')
        return meta.error
    return undefined;  
}